<template>
  <v-container>
    <v-row>
      <v-expansion-panels class="my-2 mx-4 mt-4" v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-title>
            <h2>{{ t('create_issue') }}</h2>
          </v-expansion-panel-title>
          <v-expansion-panel-text class="pa-0 ma-0">
            <create-issue :ticket="null"/>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row>
      <issues-table :ticket="ticket_id"/>
    </v-row>
  </v-container>
</template>

<script setup>
import CreateIssue from "../components/CreateIssue.vue";
import IssuesTable from "../components/IssuesTable.vue";
import { useIssueStore } from "../store/issues_store.js";
import { useAuthStore } from "@/store/authstore.js";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const { t } = useI18n({ inheritLocale: true, useScope: 'local' });
const route = useRoute();
const store = useIssueStore();
const auth_store = useAuthStore();
const panel = ref(0);
const ticket_id = ref(-1);

onMounted(() => {
  auth_store.pollIfLogged(route);
  store.load_data();
  ticket_id.value = route.params['issueId'] ? Number(route.params['issueId']) : -1;
});

</script>

<i18n>
{
  "en": {
    "create_issue": "Create Issue"
  },
  "it": {
    "create_issue": "Crea Ticket"
  },
  "fr": {
    "create_issue": "Créer Ticket"
  },
  "nl": {
    "create_issue": "Maak een probleem aan"
  }
}
</i18n>


<style scoped>

</style>
